import Vue from "vue";
import App from "./App.vue";

const elements = document.querySelectorAll("#elasticSearch");

if (elements.length > 0) {
  elements.forEach(element => {
    Vue.config.productionTip = false;

    new Vue({
      render: createElement => {
        const context = {
          props: { ...element.dataset }
        };
        return createElement(App, context);
      }
    }).$mount(element);
  });
}
